import React, { useRef, createContext } from "react";
export const RefContext = createContext(undefined);

export const RefProvider = ({ children }) => {
  const componentSize = useRef({});
  const layoutRefs = useRef({
    filterCursor: {},
    filterStart: {},
    brush: {},
    pxRange: { min: undefined, max: undefined },
  });
  const comboRef = useRef(null);
  const studyRef = useRef(null);
  const historyRef = useRef(null);
  const strengthRef = useRef(null);
  const vectorset2CurrentTicker = useRef("");

  const refs = {
    componentSize,
    layoutRefs,
    comboRef,
    studyRef,
    historyRef,
    strengthRef,
    vectorset2CurrentTicker,
  };

  return refs ? (
    <RefContext.Provider value={refs}>{children}</RefContext.Provider>
  ) : null;
};
